import { PointerType } from '@df/ui/form/range-slider/pointer-type';

export class RangeSliderChangeContext {
    value!: number;
    highValue?: number;
    pointerType!: PointerType;
}
